import { Head } from "@inertiajs/react";
import React, { Fragment } from "react";

const BlankPage = () => {
  return <Fragment>
    <Head>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
  </Fragment>;
};

export default BlankPage;